import api from "api";

const tags = {
    get: (with_events = 0) => {
        return api().get('/tags', { params: { with_events } });
    },
};

export default tags;  